import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Modal from '../../common/Modal';
import DatePicker from '../../common/DatePicker';
import CampaignVerbiage from '../containers/CampaignVerbiage';
import ScheduleCampaignFooter from './ScheduleCampaignFooter';
import ScheduleRecurringCampaignHeaderContainer from '../containers/ScheduleRecurringCampaignHeader';
import { timeOptions } from '../helpers';


const ScheduleRecurringCampaign = ({
  close,
  dayOfWeek,
  endDate,
  frequency,
  isLapsedCampaign,
  onDateEndChange,
  onDateStartChange, // eslint-disable-line
  onDateStartChangeWithEffect,
  onHideEndDatePicker,
  onSendToAllCustomersToggle,
  onSetDayOfWeek,
  onShowEndDatePicker,
  onUpdateFrequency,
  onUpdateTime,
  recurringDangerSwitch,
  scheduleCampaign,
  showDateEndPicker,
  startDate,
  submitting,
  time,
}) => (
  <Modal showHeader={false} close={close}>
    <div className="u-pt- u-bg-white c-engagement-modal">
      <h2 className="c-heading u-ml u-text-center u-pt">{isLapsedCampaign ? 'Lapsed Campaign' : 'Custom Campaign'}</h2>
      <div className="u-mt+">
        <ScheduleRecurringCampaignHeaderContainer
          isLapsedCampaign={isLapsedCampaign}
          recurringDangerSwitch={recurringDangerSwitch}
          onSendToAllCustomersToggle={onSendToAllCustomersToggle}
        />
      </div>
      <div className="u-mt+">
        <fieldset className="u-margin-auto u-max-width-360" disabled={submitting}>
          <div className="o-tableize__row">
            <div className="o-tableize__cell u-text-right u-pb-">
              <label className="c-label-new" htmlFor="frequency">
                Frequency
              </label>
            </div>
            <div className="o-tableize__cell o-tableize__cell--fill u-pl u-pb-">
              <select
                className="c-select"
                value={frequency}
                onChange={e => onUpdateFrequency(e)}
              >
                <option value="1">Daily</option>
                <option value="7">Weekly</option>
              </select>
            </div>
          </div>
          <div className="o-tableize__row" display-if={frequency === '7'}>
            <div className="o-tableize__cell u-text-right u-pb-">
              <label className="c-label-new" htmlFor="frequency">
                Day Of Week
              </label>
            </div>
            <div className="o-tableize__cell o-tableize__cell--fill u-pl u-pb-">
              <select
                className="c-select"
                value={dayOfWeek}
                onChange={e => onSetDayOfWeek(e.target.value)}
              >
                <option value="1">Monday</option>
                <option value="2">Tuesday</option>
                <option value="3">Wednesday</option>
                <option value="4">Thursday</option>
                <option value="5">Friday</option>
                <option value="6">Saturday</option>
                <option value="0">Sunday</option>
              </select>
            </div>
          </div>
          <div className="o-tableize__row">
            <div className="o-tableize__cell u-text-right u-pb-">
              <label className="c-label-new" htmlFor="time">
                Time
                </label>
            </div>
            <div className="o-tableize__cell o-tableize__cell--fill u-pl u-pb-">
              <select
                className="c-select"
                defaultValue={time}
                onChange={e => onUpdateTime(e)}
                name="recurringTime"
              >
                {timeOptions.map(timeMap => (
                  <option value={timeMap.value} key={timeMap.value}>
                    {timeMap.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="o-tableize__row">
            <div className="o-tableize__cell u-text-center u-pb-" />
            <div className="o-tableize__cell o-tableize__cell--fill u-pl u-pb-">
              <hr className="c-separator u-mt u-mb" />
            </div>
          </div>
          <div className="o-tableize__row" display-if={frequency === '1'}>
            <div className="o-tableize__cell u-text-right u-pb-">
              <label className="c-label-new" htmlFor="recurringStartDate">
                Start Date
              </label>
            </div>
            <div className="o-tableize__cell o-tableize__cell--fill u-pl u-pb-">
              <DatePicker
                className="c-input u-1/1"
                name="recurringStartDate"
                type="text"
                startDate={new Date()}
                onChange={onDateStartChangeWithEffect}
                value={startDate}
              />
            </div>
          </div>
          <div className="o-tableize__row">
            <div className="o-tableize__cell u-text-right u-pb-">
              <label className="c-label-new" htmlFor="date">
                End Date
              </label>
            </div>
            <div className="o-tableize__cell o-tableize__cell--fill u-pl u-pb-">
              <div className="c-form-input-group">
                <div className="c-form-input-group__item">
                  <button
                    className={`c-btn ${showDateEndPicker ? 'c-btn--white' : ''}`}
                    onClick={onHideEndDatePicker}
                  >INDEFINITELY</button>
                </div>
                <div className="c-form-input-group__item">
                  <button
                    className={`c-btn ${showDateEndPicker ? '' : 'c-btn--white'}`}
                    onClick={onShowEndDatePicker}
                  >PICK A DATE</button>
                </div>
              </div>
            </div>
          </div>
          {showDateEndPicker &&
            <div className="o-tableize__row">
              <div className="o-tableize__cell u-text-right u-pb-">
                <label className="c-label-new" htmlFor="recurringEndDate" />
              </div>
              <div className="o-tableize__cell o-tableize__cell--fill u-pl u-pb-">
                <DatePicker
                  className="c-input u-1/1"
                  name="recurringEndDate"
                  type="text"
                  startDate={moment().add(1, 'day').toDate()}
                  onChange={onDateEndChange}
                  value={endDate}
                />
              </div>
            </div>
          }
        </fieldset>
        <CampaignVerbiage
          frequency={frequency}
          time={time}
          startDate={startDate}
          endDate={endDate}
          isLapsed={isLapsedCampaign}
          onHideEndDatePicker={onHideEndDatePicker}
        />
        <hr className="c-separator u-mt" />
        <ScheduleCampaignFooter
          scheduleCampaign={scheduleCampaign}
          close={close}
          submitting={submitting}
          isRecurringCampaign
        />
      </div>
    </div>
  </Modal>
);

ScheduleRecurringCampaign.propTypes = {
  close: PropTypes.func.isRequired,
  dayOfWeek: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  frequency: PropTypes.string.isRequired,
  isLapsedCampaign: PropTypes.bool.isRequired,
  onDateEndChange: PropTypes.func.isRequired,
  onDateStartChange: PropTypes.func.isRequired,
  onDateStartChangeWithEffect: PropTypes.func.isRequired,
  onHideEndDatePicker: PropTypes.func.isRequired,
  onSendToAllCustomersToggle: PropTypes.func.isRequired,
  onSetDayOfWeek: PropTypes.func.isRequired,
  onShowEndDatePicker: PropTypes.func.isRequired,
  onUpdateFrequency: PropTypes.func.isRequired,
  onUpdateTime: PropTypes.func.isRequired,
  recurringDangerSwitch: PropTypes.bool.isRequired,
  scheduleCampaign: PropTypes.func.isRequired,
  showDateEndPicker: PropTypes.bool.isRequired,
  startDate: PropTypes.string.isRequired,
  submitting: PropTypes.bool.isRequired,
  time: PropTypes.string.isRequired,
};

export default ScheduleRecurringCampaign;
